// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"26f2c5f4","803":"134195eb"}[chunkId] + ".chunk.js";
};